import React from "react";
import Joi from "joi-browser";
import { toast } from "react-toastify";
import { Form, Button, Spinner } from "react-bootstrap";
import { getRouterById, updateRouter, getRouters } from "../services/routerService";
import FormComponent from "./common/formComponent";
import PageLoading from "./common/pageLoading";
import { Paper } from "@material-ui/core";

class RouterInfo extends FormComponent {
  state = {
    data: {
      _id: "",
      name: "",
      role: "",
      radiusServerId: undefined,
      vendor: "",
      model: "",
      host: "",
      sshPort: "",
      username: "",
      password: "",
      pingTime: "",
      oltGemIndex: undefined,
      oltVlan: undefined
    },
    errors: {},
    routers: [],
    radiusServers: [],
    loading: true,
    processing: false,
  };

  schema = {
    _id: Joi.string().required().label("Id"),
    name: Joi.string().required().label("Name"),
    role: Joi.string().required().label("Role"),
    radiusServerId: Joi.string().label("Radius Server").when('role', { is: 'NAS', then: Joi.required()}),
    vendor: Joi.string().required().label("Vendor"),
    model: Joi.string().required().label("Model"),
    host: Joi.string().required().label("Host/IP"),
    sshPort: Joi.number().min(1).required().label("SSH Port"),
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
    pingTime: Joi.string().required().label("Ping Time"),
    oltGemIndex: Joi.number().min(0).label("OLT Gem Index").when('role', { is: 'NAS', then: Joi.required()}),
    oltVlan: Joi.number().min(1).label("OLT VLAN ID").when('role', { is: 'NAS', then: Joi.required()}),
  };

  doSubmit = async () => {
    this.setState({ processing: true });
    const { data: payload } = this.state;

    try {
      await updateRouter(payload);

      this.props.history.push("/routers");
      toast.success("Router Updated");
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
      }
    }
    this.setState({ processing: false });
  };

  async populateRouters() {
    try {
      const { data: routers } = await getRouters();
      return routers
    } catch (ex) {
      if (ex.response && ex.response.status >= 400 && ex.response.status < 500) {
        toast.error(ex.response.data);
        this.setState({ loading: false });
      }
    }
  }

  async componentDidMount() {
    const { data } = await getRouterById(this.props.match.params.id);
    const routers = await this.populateRouters();
    const radiusServers = routers.filter((r) => r.role === "Radius Server");
    this.setState({ loading: false, data, routers, radiusServers });
  }

  render() {
    const { data, radiusServers, errors, loading, processing } = this.state;

    return (
      <Paper elevation={3}>
        <div className="card">
          <div className="card-header main-color-bg">
            <div className="row">
              <div className="col-md">
                <h5>
                  {data.name} ({data.host})
                </h5>
              </div>
              <div className="col-md"></div>
            </div>
          </div>
          <div className="card-body">
            {loading && <PageLoading loading={loading} />}
            {!loading && (
              <Form onSubmit={this.handleSubmit}>
                <Form.Group controlId="name">
                  <Form.Label>Name</Form.Label>
                  <Form.Control
                    name="name"
                    onChange={this.handleChange}
                    value={data.name}
                    size="sm"
                    type="text"
                    autoFocus
                  />
                  {errors.name && <span className="text-danger">{errors.name}</span>}
                </Form.Group>

                <Form.Group controlId="category">
                <Form.Label>Role</Form.Label>
                <Form.Control as="select" name="role" value={data.role} onChange={this.handleRouterRoleSelect}>
                  <option></option>
                  <option>Aggregator</option>
                  <option>BGP</option>
                  <option>NAS</option>
                  <option>Radius Server</option>
                </Form.Control>
                {errors.role && <span className="text-danger">{errors.role}</span>}
              </Form.Group>

              {radiusServers.length > 0 && <Form.Group controlId="category">
                <Form.Label>Radius Server</Form.Label>
                <Form.Control as="select" name="radiusServerId" value={data.radiusServerId} onChange={this.handleChange}>
                <option value="">Select Radius Server</option>
                  {radiusServers.map((radius) => (
                    <option key={radius._id} value={radius._id}>
                      {radius.name} ({radius.host})
                    </option>
                  ))}
                </Form.Control>
                {errors.radiusServerId && <span className="text-danger">{errors.radiusServerId}</span>}
              </Form.Group>}

              {radiusServers.length > 0 && <Form.Group controlId="oltGemIndex">
                <Form.Label>OLT GEM Index</Form.Label>
                <Form.Control name="oltGemIndex" onChange={this.handleChange} value={data.oltGemIndex} size="sm" type="number" />
                {errors.oltGemIndex && <span className="text-danger">{errors.oltGemIndex}</span>}
              </Form.Group>}

              {radiusServers.length > 0 && <Form.Group controlId="oltVlan">
                <Form.Label>OLT VLAN ID</Form.Label>
                <Form.Control name="oltVlan" onChange={this.handleChange} value={data.oltVlan} size="sm" type="number" />
                {errors.oltVlan && <span className="text-danger">{errors.oltVlan}</span>}
              </Form.Group>}

                <Form.Group controlId="vendor">
                  <Form.Label>Vendor</Form.Label>
                  <Form.Control name="vendor" onChange={this.handleChange} value={data.vendor} size="sm" type="text" />
                  {errors.vendor && <span className="text-danger">{errors.vendor}</span>}
                </Form.Group>

                <Form.Group controlId="model">
                  <Form.Label>Model</Form.Label>
                  <Form.Control name="model" onChange={this.handleChange} value={data.model} size="sm" type="text" />
                  {errors.model && <span className="text-danger">{errors.model}</span>}
                </Form.Group>

                <Form.Group controlId="host">
                  <Form.Label>Host/IP</Form.Label>
                  <Form.Control name="host" onChange={this.handleChange} value={data.host} size="sm" type="text" />
                  {errors.host && <span className="text-danger">{errors.host}</span>}
                </Form.Group>

                <Form.Group controlId="sshPort">
                  <Form.Label>SSH Port</Form.Label>
                  <Form.Control
                    name="sshPort"
                    onChange={this.handleChange}
                    value={data.sshPort}
                    size="sm"
                    type="text"
                  />
                  {errors.sshPort && <span className="text-danger">{errors.sshPort}</span>}
                </Form.Group>

                <Form.Group controlId="username">
                  <Form.Label>Username</Form.Label>
                  <Form.Control
                    name="username"
                    onChange={this.handleChange}
                    value={data.username}
                    size="sm"
                    type="text"
                  />
                  {errors.username && <span className="text-danger">{errors.username}</span>}
                </Form.Group>

                <Form.Group controlId="password">
                  <Form.Label>Password</Form.Label>
                  <Form.Control
                    name="password"
                    onChange={this.handleChange}
                    value={data.password}
                    size="sm"
                    type="password"
                  />
                  {errors.password && <span className="text-danger">{errors.password}</span>}
                </Form.Group>
                <Button disabled={this.validate() || processing} type="submit" variant="primary">
                  {processing && (
                    <Spinner as="span" className="mr-2" animation="border" size="sm" role="status" aria-hidden="true" />
                  )}
                  Update
                </Button>
              </Form>
            )}
          </div>
        </div>
      </Paper>
    );
  }
}

export default RouterInfo;
